export const purple = "#472453";
export const green = "#63AF00";
export const orange = "#F39C12";
export const pink = "#EA3C96";
